import React from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { Link } from "react-router-dom";

import CollapseHeader from "../../../core/common/collapse-header";

const EmailSettings = () => {
  return (
    <div>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h4 className="page-title">
                      <i className="ti ti-mail text-primary me-2" />
                      Email Settings
                    </h4>
                  </div>
                  <div className="col-4 text-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              {/* Settings Menu */}
              <div className="row">
                <div className="col-xl-12 col-lg-12">
                  {/* Settings Info */}
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-4">
                        <h4 className="fs-20">Email Settings</h4>
                        <Link
                          to="#"
                          className="btn-add"
                          data-bs-toggle="modal"
                          data-bs-target="#add_mail"
                        >
                          <i className="ti ti-mail" />
                        </Link>
                      </div>
                      <div className="row">
                        {/* Email Wrap */}
                        <div className="col-md-12">
                          
                          <div className="border rounded p-3 mb-4">
                            <div className="row gy-3">
                              <div className="col-sm-5">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avtar-lg border me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/icons/mail-02.svg"
                                      className="w-auto h-auto"
                                      alt=""
                                    />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1">SMTP</h6>
                                    <Link
                                      to="#"
                                      className="badge bg-soft-success"
                                    >
                                      Connected
                                    </Link>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-7">
                                <div className="d-flex align-items-center justify-content-between">
                                  <div>
                                    <Link
                                      to="#"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#add-smtp"
                                      className="info-icon me-3 text-default"
                                    >
                                      <i className="ti ti-info-circle-filled me-1" />
                                    </Link>
                                    <Link
                                      to="#"
                                      className="btn btn-light"
                                      data-bs-toggle="modal"
                                      data-bs-target="#add_smtp"
                                    >
                                      <i className="ti ti-tool me-1" />
                                      View Integration
                                    </Link>
                                  </div>
                                  <div className="status-toggle">
                                    <input
                                      type="checkbox"
                                      id="mail2"
                                      className="check"
                                      defaultChecked
                                    />
                                    <label
                                      htmlFor="mail2"
                                      className="checktoggle"
                                    >
                                      {" "}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="collapse" id="add-smtp">
                              <div className="mail-collapse">
                                <p>
                                  SMTP (Simple Mail Transfer Protocol) is the
                                  standard protocol for sending emails across
                                  networks. It is used to transfer messages from
                                  an email client to a mail server and between
                                  mail servers. SMTP works on ports 25, 465, or
                                  587 and handles only sending, not receiving
                                  emails.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="border rounded p-3 mb-4">
                            <div className="row gy-3">
                              <div className="col-sm-5">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avtar-lg border me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/icons/mail-01.svg"
                                      className="w-auto h-auto"
                                      alt=""
                                    />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1">
                                      PHP Mailer
                                    </h6>
                                    <Link
                                      to="#"
                                      className="badge bg-soft-purple text-purple"
                                    >
                                      Not Connected
                                    </Link>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-7">
                                <div className="d-flex align-items-center justify-content-between">
                                  <div>
                                    <Link
                                      to="#"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#php-mail"
                                      className="info-icon me-3 text-default"
                                    >
                                      <i className="ti ti-info-circle-filled me-1" />
                                    </Link>
                                    <Link
                                      to="#"
                                      className="btn btn-light"
                                      data-bs-toggle="modal"
                                      data-bs-target="#add_phpmail"
                                    >
                                      <i className="ti ti-tool me-1" />
                                      View Integration
                                    </Link>
                                  </div>
                                  <div className="status-toggle">
                                    <input
                                      type="checkbox"
                                      id="mail1"
                                      className="check"
                                      defaultChecked
                                    />
                                    <label
                                      htmlFor="mail1"
                                      className="checktoggle"
                                    >
                                      {" "}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="collapse" id="php-mail">
                              <div className="mail-collapse">
                                <p>
                                  PHPMailer is a third-party PHP library that
                                  provides a simple way to send emails in PHP.
                                  It offers a range of features that make it a
                                  popular alternative to PHP's built-in mail()
                                  function, such as support for HTML emails,
                                  attachments, and SMTP authentication.
                                </p>
                              </div>
                            </div>
                          </div>
                         <div className="border rounded p-3 mb-4">
                            <div className="row gy-3">
                              <div className="col-sm-5">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avtar-lg border me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/icons/mail-03.svg"
                                      className="w-auto h-auto"
                                      alt=""
                                    />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1">SendGrid</h6>
                                    <Link
                                      to="#"
                                      className="badge bg-soft-purple text-purple"
                                    >
                                      Not Connected
                                    </Link>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-7">
                                <div className="d-flex align-items-center justify-content-between">
                                  <div>
                                   <Link
                                      to="#"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#send-grid"
                                      className="info-icon me-3 text-default"
                                    >
                                      <i className="ti ti-info-circle-filled me-1" />
                                    </Link>
                                    <Link to="#" className="btn btn-primary">
                                      <i className="ti ti-plug-connected me-1" />
                                      Connect Now
                                    </Link>
                                  </div>
                                  <div className="status-toggle">
                                    <input
                                      type="checkbox"
                                      id="mail3"
                                      className="check"
                                      defaultChecked
                                    />
                                    <label
                                      htmlFor="mail3"
                                      className="checktoggle"
                                    >
                                      {" "}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="collapse" id="send-grid">
                              <div className="mail-collapse">
                                <p>
                                  SendGrid is a cloud-based email delivery
                                  service that provides SMTP relay and APIs for
                                  sending, receiving, and tracking emails. It
                                  helps developers and businesses manage
                                  transactional emails (like password resets,
                                  receipts) and marketing emails (like
                                  newsletters). SendGrid also offers features
                                  like analytics, scalability, and
                                  deliverability optimization to ensure emails
                                  reach inboxes reliably.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="border rounded p-3 mb-4">
                            <div className="row gy-3">
                              <div className="col-sm-5">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avtar-lg border me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/icons/Zepto.png"
                                      className="w-auto h-auto"
                                      alt=""
                                    />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1">Zepto</h6>
                                    <Link
                                      to="#"
                                      className="badge bg-soft-purple text-purple"
                                    >
                                      Not Connected
                                    </Link>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-7">
                                <div className="d-flex align-items-center justify-content-between">
                                  <div>
                                    <Link
                                      to="#"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#zepto"
                                      className="info-icon me-3 text-default"
                                    >
                                      <i className="ti ti-info-circle-filled me-1" />
                                    </Link>
                                    <Link
                                      to="#"
                                      className="btn btn-light"
                                      data-bs-toggle="modal"
                                      data-bs-target="#add_smtp"
                                    >
                                      <i className="ti ti-tool me-1" />
                                      View Integration
                                    </Link>
                                  </div>
                                  <div className="status-toggle">
                                    <input
                                      type="checkbox"
                                      id="mail2"
                                      className="check"
                                      defaultChecked
                                    />
                                    <label
                                      htmlFor="mail2"
                                      className="checktoggle"
                                    >
                                      {" "}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="collapse" id="zepto">
                              <div className="mail-collapse">
                                <p>
                                 ZeptoMail is a transactional email service 
                                 that allows businesses to send reliable, secure, 
                                 and fast user-triggered emails (like OTPs, password 
                                 resets, order confirmations, and notifications) 
                                 through SMTP or API, with features like domain 
                                 authentication, analytics, suppression lists, 
                                 and pay-as-you-go pricing.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="border rounded p-3 mb-4">
                            <div className="row gy-3">
                              <div className="col-sm-5">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avtar-lg border me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/icons/fastmail.png"
                                      className="w-auto h-auto"
                                      alt=""
                                    />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1">FastMail</h6>
                                    <Link
                                      to="#"
                                      className="badge bg-soft-purple text-purple"
                                    >
                                      Not Connected
                                    </Link>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-7">
                                <div className="d-flex align-items-center justify-content-between">
                                  <div>
                                    <Link
                                      to="#"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#fast-mail"
                                      className="info-icon me-3 text-default"
                                    >
                                      <i className="ti ti-info-circle-filled me-1" />
                                    </Link>
                                    <Link
                                      to="#"
                                      className="btn btn-light"
                                      data-bs-toggle="modal"
                                      data-bs-target="#add_smtp"
                                    >
                                      <i className="ti ti-tool me-1" />
                                      View Integration
                                    </Link>
                                  </div>
                                  <div className="status-toggle">
                                    <input
                                      type="checkbox"
                                      id="mail2"
                                      className="check"
                                      defaultChecked
                                    />
                                    <label
                                      htmlFor="mail2"
                                      className="checktoggle"
                                    >
                                      {" "}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="collapse" id="fast-mail">
                              <div className="mail-collapse">
                                <p>
                                  Fastmail is a privacy-focused email hosting 
                                  service that offers secure, ad-free, and reliable 
                                  email with custom domain support, calendars, contacts, 
                                  and productivity tools, emphasizing user control and 
                                  data protection.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="border rounded p-3 mb-4">
                            <div className="row gy-3">
                              <div className="col-sm-5">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avtar-lg border me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/icons/hub.png"
                                      className="w-auto h-auto"
                                      alt=""
                                    />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1">HubSpot</h6>
                                    <Link
                                      to="#"
                                     className="badge bg-soft-purple text-purple"
                                    >
                                      Not Connected
                                    </Link>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-7">
                                <div className="d-flex align-items-center justify-content-between">
                                  <div>
                                    <Link
                                      to="#"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#hub-mail"
                                      className="info-icon me-3 text-default"
                                    >
                                      <i className="ti ti-info-circle-filled me-1" />
                                    </Link>
                                    <Link
                                      to="#"
                                      className="btn btn-light"
                                      data-bs-toggle="modal"
                                      data-bs-target="#add_smtp"
                                    >
                                      <i className="ti ti-tool me-1" />
                                      View Integration
                                    </Link>
                                  </div>
                                  <div className="status-toggle">
                                    <input
                                      type="checkbox"
                                      id="mail2"
                                      className="check"
                                      defaultChecked
                                    />
                                    <label
                                      htmlFor="mail2"
                                      className="checktoggle"
                                    >
                                      {" "}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="collapse" id="hub-mail">
                              <div className="mail-collapse">
                                <p>
                                  HubSpot's email marketing software is part 
                                  of Marketing Hub, and you can get started with 
                                  it for free. If you're looking for more advanced 
                                  features to help automate and scale your marketing 
                                  operations, HubSpot also offers premium features with 
                                  the Starter, Professional, and Enterprise editions 
                                  of Marketing Hub.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* /Email Wrap */}
                      </div>
                    </div>
                  </div>
                  {/* /Settings Info */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      <>
        {/* PHP Mailer */}
        <div className="modal fade" id="add_phpmail" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">PHP Mailer</h5>
                <div className="d-flex align-items-center">
                  <div className="status-toggle me-2">
                    <input
                      type="checkbox"
                      id="toggle"
                      className="check"
                      defaultChecked
                    />
                    <label htmlFor="toggle" className="checktoggle" />
                  </div>
                  <button
                    className="btn-close custom-btn-close border p-1 me-0 text-dark"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <i className="ti ti-x" />
                  </button>
                </div>
              </div>
              <form>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="col-form-label">
                      From Email Address <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="mb-3">
                    <label className="col-form-label">
                      Email Password <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="mb-0">
                    <label className="col-form-label">
                      From Email Name <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="modal-footer">
                  <div className="d-flex align-items-center justify-content-end m-0">
                    <Link
                      to="#"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <button
                      type="button"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /PHP Mailer */}
        {/* SMTP */}
        <div className="modal fade" id="add_smtp" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">SMTP</h5>
                <div className="d-flex align-items-center">
                  <div className="status-toggle me-2">
                    <input
                      type="checkbox"
                      id="toggle1"
                      className="check"
                      defaultChecked
                    />
                    <label htmlFor="toggle1" className="checktoggle" />
                  </div>
                  <button
                    className="btn-close custom-btn-close border p-1 me-0 text-dark"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <i className="ti ti-x" />
                  </button>
                </div>
              </div>
              <form>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="col-form-label">
                      From Email Address <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="mb-3">
                    <label className="col-form-label">
                      Email Password <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="mb-3">
                    <label className="col-form-label">
                      Email Host <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="mb-0">
                    <label className="col-form-label">
                      Port <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="modal-footer">
                  <div className="d-flex align-items-center justify-content-end m-0">
                    <Link
                      to="#"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <button
                      type="button"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /SMTP */}
        {/* Test Mail */}
        <div className="modal fade" id="add_mail" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Test Mail</h5>
                <button
                  className="btn-close custom-btn-close border p-1 me-0 text-dark"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="mb-0">
                    <label className="col-form-label">
                      Enter Email Address <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="modal-footer">
                  <div className="d-flex align-items-center justify-content-end m-0">
                    <Link
                      to="#"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <button
                      type="button"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Test Mail */}
        <div className="modal fade" id="add_mail" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Test Mail</h5>
                <button
                  className="btn-close custom-btn-close border p-1 me-0 text-dark"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="mb-0">
                    <label className="col-form-label">
                      Enter Email Address <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="modal-footer">
                  <div className="d-flex align-items-center justify-content-end m-0">
                    <Link
                      to="#"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <button
                      type="button"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Test Mail */}
        <div className="modal fade" id="add_mail" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Test Mail</h5>
                <button
                  className="btn-close custom-btn-close border p-1 me-0 text-dark"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="mb-0">
                    <label className="col-form-label">
                      Enter Email Address <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="modal-footer">
                  <div className="d-flex align-items-center justify-content-end m-0">
                    <Link
                      to="#"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <button
                      type="button"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Test Mail */}
        <div className="modal fade" id="add_mail" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Test Mail</h5>
                <button
                  className="btn-close custom-btn-close border p-1 me-0 text-dark"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="mb-0">
                    <label className="col-form-label">
                      Enter Email Address <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="modal-footer">
                  <div className="d-flex align-items-center justify-content-end m-0">
                    <Link
                      to="#"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <button
                      type="button"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default EmailSettings;
